import type { User } from '@services/auth.service';

export const PLATFORM_OWNER_ROLE = 'SUPER_ADMIN';

export function isPlatformOwner(user: User | null | undefined): boolean {
  return (user?.role ?? '').toUpperCase() === PLATFORM_OWNER_ROLE;
}
